import React from 'react'
import { matchPath } from 'react-router'
import type { LinkProps } from 'rebass/styled-components'

import { TextLink } from '../Type'

interface NavigationLinkProps extends LinkProps {
  children: React.ReactNode
  className?: string
  forceRefresh?: boolean
  href?: string
  navExpanded?: boolean
  to?: string
  variant?: string
  preventScrollReset?: boolean
}

const NavigationLink = ({
  children,
  className,
  forceRefresh,
  href,
  navExpanded,
  to,
  variant = 'navPrimary',
  preventScrollReset = true, // Default to true to prevent scroll reset
  sx,
  ...props
}: NavigationLinkProps): JSX.Element => {
  const isHighlighted = to && matchPath({ path: to }, location.pathname)

  return (
    <TextLink
      to={to && !forceRefresh ? to : undefined}
      href={href && forceRefresh ? href : undefined}
      variant={variant}
      className={`${className} ${isHighlighted && navExpanded ? 'active' : ''}`}
      preventScrollReset={preventScrollReset}
      sx={{ ...sx }}
      {...props}
    >
      {children}
    </TextLink>
  )
}

export default NavigationLink
